import { gql } from "config/graphql";
import { CLASSIFICATION_FIELDS } from "gql/fragments/classification";
import { PAYOUT_DETAILS_FIELDS } from "gql/fragments/payoutDetails";
import { PRODUCT_DETAIL_FIELDS } from "gql/fragments/product";

export const POLICY_FIELDS = gql`
  ${CLASSIFICATION_FIELDS}
  ${PRODUCT_DETAIL_FIELDS}
  ${PAYOUT_DETAILS_FIELDS}
  fragment PolicyFields on Policy {
    id
    label
    amount
    status
    termDuration
    termUnit
    increaseCoverageAmountAllowed
    insuredsAgeAtTerm
    effectiveAt
    pausedAt
    terminatesAt
    lapsesAt
    effectiveUntil
    classification {
      ...ClassificationFields
    }
    accountsProduct {
      id
      amount
      billingFrequency
      nextPayment {
        date
        invoiceId
        estimated
      }
    }
    product {
      ...ProductFields
    }
    payoutDetails {
      ...PayoutDetailsFields
    }
    documents {
      id
      name
      description
      slug
      html {
        url
        fileName
      }
      pdf {
        url
        fileName
      }
      version
    }
  }
`;
